// extracted by mini-css-extract-plugin
export var container = "index-module--container--CNRdJ";
export var education = "index-module--education--LrZUk";
export var h4 = "index-module--h4--vyTMl";
export var imageContainer = "index-module--imageContainer--rBk-w";
export var more = "index-module--more--vSwuE";
export var p1 = "index-module--p1--iCCH8";
export var title = "index-module--title--LS5-S";